
import React, { Suspense, useEffect, useState } from 'react'
import Banner from "../components/Banner";
import { lazy } from 'react';

const Faq = lazy(() => import("../components/Faq.js"));
const Privileges = lazy(() => import("../components/Privileges.js"));
const Footer = lazy(() => import("../components/Footer.js"));

function Homepage() {
  const [executed, setExecuted] = useState(false);
  const [syncADL, setSyncADL] = useState(0);

    // Gtags
//   useEffect(() => {
//     // Initialize if already loaded, else wait for it
//     if (window.gtag) {
//       window.gtag("config", "AW-848956189");
//       window.gtag("config", "AW-961178487");
//     }

//   }, []);

    //bing tag
    // useEffect(() => {
    //     // Initialize UET queue if not already
    //     window.uetq = window.uetq || [];

    //     // Create the Bing UET script
    //     const script = document.createElement("script");
    //     script.src = "//bat.bing.com/bat.js";
    //     script.async = true;

    //     script.onload = script.onreadystatechange = function () {
    //         const rs = this.readyState;
    //         if (!rs || rs === "loaded" || rs === "complete") {
    //             const o = {
    //                 ti: "97123908",
    //                 enableAutoSpaTracking: true,
    //             };
    //             o.q = window.uetq;
    //             window.uetq = new window.UET(o);
    //             window.uetq.push("pageLoad");

    //             script.onload = script.onreadystatechange = null;
    //         }
    //     };

    //     const firstScript = document.getElementsByTagName("script")[0];
    //     if (firstScript && firstScript.parentNode) {
    //         firstScript.parentNode.insertBefore(script, firstScript);
    //     }

        // Optional cleanup
    //     return () => {
    //         if (script.parentNode) {
    //             script.parentNode.removeChild(script);
    //         }
    //     };
    // }, []);

  //FB tag
// useEffect(() => {
//         const firePageView = () => {
//             if (window.fbq) {
//             window.fbq("track", "PageView");
//             window.fbq('track','Alumni-LP-1-Oct-24New');
//             } else {
//             setTimeout(firePageView, 300);
//             }
//         };

//         firePageView();
//         }, []);

   //-----------LinkedIn tag-----------
    // useEffect(() => {
    //     // Set LinkedIn Partner ID
    //     window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    //     window._linkedin_data_partner_ids.push("7810465");

    //     // Create script tag for LinkedIn insight.min.js
    //     const script = document.createElement("script");
    //     script.type = "text/javascript";
    //     script.async = true;
    //     script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

    //     const firstScript = document.getElementsByTagName("script")[0];
    //     if (firstScript && firstScript.parentNode) {
    //         firstScript.parentNode.insertBefore(script, firstScript);
    //     }

    //     // Optional: Clean up the script on unmount
    //     return () => {
    //         if (script.parentNode) {
    //             script.parentNode.removeChild(script);
    //         }
    //     };
    // }, []);

//-----------clarity-----------
    //   useEffect(() => {
    //         (function (c, l, a, r, i, t, y) {
    //           c[a] =
    //             c[a] ||
    //             function () {
    //               (c[a].q = c[a].q || []).push(arguments);
    //             };
    //           t = l.createElement(r);
    //           t.async = 1;
    //           t.src = "https://www.clarity.ms/tag/" + i;
    //           y = l.getElementsByTagName(r)[0];
    //           y.parentNode.insertBefore(t, y);
    //         })(window, document, "clarity", "script", "tjdal8nflp");
    //       }, []);

          //Gtag
// useEffect(() => {
//         // Inject gtag.js only once
//         if (!document.getElementById("gtag-js")) {
//             const script = document.createElement("script");
//             script.id = "gtag-js";
//             script.async = true;
//             script.src = "https://www.googletagmanager.com/gtag/js?id=AW-818835661"; // only one is needed
//             document.head.appendChild(script);
//         }

//         const initGtag = () => {
//             window.dataLayer = window.dataLayer || [];

//             function gtag() {
//                 window.dataLayer.push(arguments);
//             }

//             window.gtag = gtag;

//             // Initialize gtag with both Ads tracking IDs
//             gtag("js", new Date());
//             window.gtag('config', 'AW-818835661');
//          window.gtag('event', 'conversion', {'send_to': 'AW-818835661/F6alCJPx9eQZEM3huYYD'});
//         };

//         // Initialize if already loaded, else wait for it
//         if (window.gtag) {
//            window.gtag('config', 'AW-818835661');
//             window.gtag('event', 'conversion', {'send_to': 'AW-818835661/F6alCJPx9eQZEM3huYYD'});
//         } else {
//             const existingScript = document.getElementById("gtag-js");
//             existingScript?.addEventListener("load", initGtag);
//         }
//     }, []);

//invmedia
//   useEffect(() => {
//           const script = document.createElement("script");
//             script.src = "https://www.googletagmanager.com/gtag/js?id=DC-8971752";
//             script.async = true;
//             document.head.appendChild(script);

//             // Initialize gtag after script loads
//             script.onload = () => {
//                 window.dataLayer = window.dataLayer || [];
//                 function gtag() {
//                     window.dataLayer.push(arguments);
//                 }
//                 window.gtag = gtag; // make globally available
//                 gtag("js", new Date());
//                 gtag("config", "DC-8971752");
//                 gtag("event", "conversion", {
//                     allow_custom_scripts: true,
//                     'send_to': 'DC-8971752/invmedia/icici030+standard'

//                 });
//             };
// }, []);




  return (
    <>
      <Suspense fallback={<>Loading...</>}>
      <main id="main-content">
        <Banner />      
        <Privileges />
        <Faq />
      </main>
      <Footer />
      </Suspense>

    </>
  );
}

export default Homepage;
